export default __webpack_public_path__ + "static/media/test-series.8373fe2d.png";